var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mb-5 mr-8",attrs:{"color":"primary","small":""},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._t("default",function(){return [_vm._v("Verder")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }